export class Product {
    ProductCode: string = "";
    ProductType: string = "HS Code";
    Description: string = "";
    PersonalEffectType:string="";
    ProductNameARA:string="";
}

export class ListOfDCHSCODELIST {
    PRODUCT: Product = new Product();
}

export class IncomingHierarchy {
    MessageId: string = ""; // should be set dynamically
    IntObjectName: string = "DCHSCODELIST";
    MessageType: string = "Integration Object";
    IntObjectFormat: string = "Siebel Hierarchical";
    ListOfDCHSCODELIST: ListOfDCHSCODELIST = new ListOfDCHSCODELIST();
}

export class HSCodeRequestBody {
    ProcessName: string = "DC Get HS Code List WF";
    IncomingHierarchy: IncomingHierarchy = new IncomingHierarchy();
    PageSize: string = "5";
    StartRowNum: number = 0;
    NewQuery: string = "true";
    DCLanguage:string="ENU"
}

export class HSCodeRequest {
    body: HSCodeRequestBody = new HSCodeRequestBody();
}
